"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_path = require("path");
var import_vitest = require("vitest");
var PROJECT_ROOT = (0, import_path.resolve)("/project");
(0, import_vitest.describe)("criticalCSSPlugin", function() {
  (0, import_vitest.beforeEach)(function() {
    import_vitest.vi.resetModules();
  });
  (0, import_vitest.afterEach)(function() {
    import_vitest.vi.clearAllMocks();
  });
  (0, import_vitest.describe)("resolveId", function() {
    (0, import_vitest.it)("filters out non-inline CSS imports before the handler runs", async function() {
      var { criticalCSSPlugin } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      var filter = plugin.resolveId.filter.id;
      (0, import_vitest.expect)(filter.test("./styles.css")).toBe(false);
      (0, import_vitest.expect)(filter.test("./data.json")).toBe(false);
      (0, import_vitest.expect)(filter.test("./styles.inline.css")).toBe(true);
    });
    (0, import_vitest.it)("should resolve .inline.css and track it", async function() {
      var { criticalCSSPlugin } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      plugin.configResolved({
        root: PROJECT_ROOT
      });
      var resolvedCssPath = (0, import_path.resolve)("/project/src/styles.inline.css");
      var mockResolve = import_vitest.vi.fn().mockResolvedValue({
        id: resolvedCssPath
      });
      var importerPath = (0, import_path.resolve)("/project/src/App.tsx");
      var result = await plugin.resolveId.handler.call({
        resolve: mockResolve
      }, "./styles.inline.css", importerPath);
      (0, import_vitest.expect)(mockResolve).toHaveBeenCalledWith("./styles.inline.css", importerPath, {
        skipSelf: true
      });
      (0, import_vitest.expect)(result).toEqual({
        id: resolvedCssPath
      });
    });
    (0, import_vitest.it)("should track inline CSS source paths", async function() {
      var { criticalCSSPlugin, getCriticalCSSSources } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      plugin.configResolved({
        root: PROJECT_ROOT
      });
      var mockResolve = import_vitest.vi.fn().mockResolvedValue({
        id: (0, import_path.resolve)("/project/src/layout.inline.css")
      });
      await plugin.resolveId.handler.call({
        resolve: mockResolve
      }, "./layout.inline.css", (0, import_path.resolve)("/project/src/App.tsx"));
      var sources = getCriticalCSSSources();
      (0, import_vitest.expect)(sources.has("src/layout.inline.css") || sources.has("src\\layout.inline.css")).toBe(true);
    });
    (0, import_vitest.it)("should return null when resolve fails", async function() {
      var { criticalCSSPlugin } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      plugin.configResolved({
        root: PROJECT_ROOT
      });
      var mockResolve = import_vitest.vi.fn().mockResolvedValue(null);
      var result = await plugin.resolveId.handler.call({
        resolve: mockResolve
      }, "./nonexistent.inline.css", (0, import_path.resolve)("/project/src/App.tsx"));
      (0, import_vitest.expect)(result).toBeNull();
    });
  });
  (0, import_vitest.describe)("getCriticalCSSOutputPaths", function() {
    (0, import_vitest.it)("should map inline CSS source to output paths via manifest", async function() {
      var { criticalCSSPlugin, getCriticalCSSSources, getCriticalCSSOutputPaths } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      plugin.configResolved({
        root: PROJECT_ROOT
      });
      var mockResolve = import_vitest.vi.fn().mockResolvedValue({
        id: (0, import_path.resolve)("/project/app/layout.inline.css")
      });
      await plugin.resolveId.handler.call({
        resolve: mockResolve
      }, "./layout.inline.css", (0, import_path.resolve)("/project/app/_layout.tsx"));
      var sources = getCriticalCSSSources();
      var sourceKey = [
        ...sources
      ].find(function(s) {
        return s.includes("layout.inline.css");
      });
      var manifest = {
        [sourceKey]: {
          file: "assets/layout-abc123.css",
          src: sourceKey
        },
        "app/_layout.tsx": {
          file: "assets/layout-def456.js",
          css: [
            "assets/layout-abc123.css"
          ],
          imports: [],
          name: "_layout"
        }
      };
      var outputPaths = getCriticalCSSOutputPaths(manifest);
      (0, import_vitest.expect)(outputPaths.has("/assets/layout-abc123.css")).toBe(true);
    });
    (0, import_vitest.it)("should return empty set when no inline CSS exists", async function() {
      var { getCriticalCSSOutputPaths } = await import("./criticalCSSPlugin");
      var manifest = {
        "app/styles.css": {
          file: "assets/styles-abc.css"
        }
      };
      var outputPaths = getCriticalCSSOutputPaths(manifest);
      (0, import_vitest.expect)(outputPaths).toBeDefined();
    });
  });
  (0, import_vitest.describe)("plugin metadata", function() {
    (0, import_vitest.it)("should have correct name", async function() {
      var { criticalCSSPlugin } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      (0, import_vitest.expect)(plugin.name).toBe("one:critical-css");
    });
    (0, import_vitest.it)("should enforce pre", async function() {
      var { criticalCSSPlugin } = await import("./criticalCSSPlugin");
      var plugin = criticalCSSPlugin();
      (0, import_vitest.expect)(plugin.enforce).toBe("pre");
    });
  });
});
//# sourceMappingURL=criticalCSSPlugin.test.js.map
